import { transformNullIntoEmpty } from '../../utils/DataUtils';
import {
  CHANGED_AGENDA_ASSESSORES_PEDAGOGICOS_EDITING_VALUE_ACTION,
  CLEARED_AGENDA_ASSESSORES_PEDAGOGICOS_EDITING_VALUE_ACTION,
  LOADED_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION,
  LOADED_AGENDA_ASSESSORES_PEDAGOGICOS_DATA_ATUAL_ACTION,
  LOADED_DASHBOARD_ACTION,
  LOADED_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION,
  LOADING_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION,
  LOADING_AGENDA_ASSESSORES_PEDAGOGICOS_DATA_ATUAL_ACTION,
  LOADING_DASHBOARD_ACTION,
  LOADING_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION,
} from './AgendaAssessoresPedagogicosActions';

const EVENTO_EDITING_NOT_NULL_PROPS = [
  'descricao',
  'assunto',
  'codCoop',
  'cpfAssessor',
  'data',
  'horaIntervalo',
  'horaInicialIntervalo',
  'horaFinalIntervalo',
  'horaInicial',
  'horaFinal',
  'atividades',
];

const EVENTO_EDITING_INITIAL_STATE = {
  id: null,
  tipoAgenda: null,
  descricao: '',
  assunto: '',
  codCoop: '',
  assessorConvidado: false,
  cpfAssessor: '',
  data: '',
  horaIntervalo: false,
  horaInicialIntervalo: '',
  horaFinalIntervalo: '',
  horaInicial: '',
  horaFinal: '',
  idsEscolas: [],
  atividades: '',
  isAprovado: false,
  status: null,
};

const INITIAL_STATE = {
  loadingDataAtual: false,
  dataAtual: null,

  loadingEventos: false,
  eventos: null,

  loadingEventoEditing: false,
  /* object {
    id: Number,
    tipoAgenda: Number,
    descricao: String,
    assunto: String,
    codCoop: String,
    assessorConvidado: Boolean,
    cpfAssessor: String,
    data: String,
    horaInicial: String,
    horaFinal: String,
    idEscola: Number,
    atividades: String,
    isAprovado: Boolean,
    status: Number
  }*/
  eventoEditing: EVENTO_EDITING_INITIAL_STATE,
  loadingDashboard: false,
  dashboard: [],
};

export default function AgendaAssessoresPedagogicosReducer(
  state = INITIAL_STATE,
  action
) {
  switch (action.type) {
    case LOADING_AGENDA_ASSESSORES_PEDAGOGICOS_DATA_ATUAL_ACTION:
      return {
        ...state,
        loadingDataAtual: action.payload,
      };
    case LOADED_AGENDA_ASSESSORES_PEDAGOGICOS_DATA_ATUAL_ACTION:
      return {
        ...state,
        dataAtual: action.payload,
      };
    case LOADING_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION:
      return {
        ...state,
        loadingEventos: action.payload,
      };
    case LOADED_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION:
      return {
        ...state,
        eventos: action.payload,
      };
    case CLEARED_AGENDA_ASSESSORES_PEDAGOGICOS_EDITING_VALUE_ACTION:
      return { ...state, eventoEditing: EVENTO_EDITING_INITIAL_STATE };
    case CHANGED_AGENDA_ASSESSORES_PEDAGOGICOS_EDITING_VALUE_ACTION:
      return {
        ...state,
        eventoEditing: {
          ...state.eventoEditing,
          [action.payload.name]: action.payload.value,
        },
      };
    case LOADING_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION:
      return { ...state, loadingEventoEditing: action.payload };
    case LOADED_EVENTO_AGENDA_ASSESSORES_PEDAGOGICOS_ACTION:
      return {
        ...state,
        eventoEditing: transformNullIntoEmpty(
          {
            ...state.eventoEditing,
            ...action.payload,
          },
          EVENTO_EDITING_NOT_NULL_PROPS
        ),
      };
    case LOADING_DASHBOARD_ACTION:
      return {
        ...state,
        loadingDashboard: action.payload,
      };
    case LOADED_DASHBOARD_ACTION:
      return {
        ...state,
        dashboard: action.payload,
      };
    default:
      return state;
  }
}
